import {css} from 'styled-components';

export const ButtonBaseCss = css`
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border: 1px solid transparent;
    border-radius: 0.25rem;
`;
